import type { PerformanceFilters } from '../types';

export const LABOR_PERFORMANCE_KEYS = {
  all: ['labor-performance'] as const,

  byOrg: (orgId: string) => ['labor-performance', orgId] as const,

  summary: (orgId: string, periodStart: string, periodEnd: string) =>
    ['labor-performance', orgId, 'summary', periodStart, periodEnd] as const,

  timeline: (orgId: string, filters: PerformanceFilters) =>
    ['labor-performance', orgId, 'timeline', filters] as const,

  table: (orgId: string, filters: PerformanceFilters) =>
    ['labor-performance', orgId, 'table', filters] as const,

  projects: (orgId: string, periodStart: string, periodEnd: string) =>
    ['labor-performance', orgId, 'projects', periodStart, periodEnd] as const,
};
